import { Footer } from '../../../docs/home/components/Footer'
export { Main } from './Main'
export { Topbar } from './Topbar'
export { Sidebar } from './Sidebar'
export { Footer }
